import axios from 'axios';
import { useZstdLoading } from 'ctls/common/useZstdLoading';
import queryString from 'query-string';
import { applyCommonInterceptors } from './axiosutil';

const paxios = axios.create();
applyCommonInterceptors(paxios, 'paxios');

paxios.interceptors.request.use(
  (config) => {
    useZstdLoading.getState().inc();
    // 기본 파라미터 시리얼라이저 설정
    if (!config.paramsSerializer) {
      //   config.paramsSerializer = (params) => {
      //     if (!params) return;
      //     return queryString.stringify(params);
      //   };
      config.paramsSerializer = {
        serialize: (params) => {
          if (!params) return;
          return queryString.stringify(params);
        },
      };
    }
    return config;
  },
  (error) => {
    useZstdLoading.getState().dec();
    return Promise.reject(error);
  }
);

paxios.interceptors.response.use(
  (response) => {
    useZstdLoading.getState().dec();
    return response;
  },
  (error) => {
    useZstdLoading.getState().dec();
    return Promise.reject(error);
  }
);

export { paxios };
